import React from 'react';
import SearchCardSkeleton from './SearchCardSkeleton';

const SearchGridSkeleton = ({ count = 6 }) => {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <SearchCardSkeleton key={`skeleton-${index}`} />
      ))}
    </>
  );
};

export default SearchGridSkeleton;